// src/pages/ConfirmJobCompletion.js
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ref, update } from "firebase/database";
import { db } from "../utilities/firebaseConfig";

const ConfirmJobCompletion = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const handleConfirm = async () => {
    try {
      await update(ref(db, `jobs/${jobId}`), { status: "completed", confirmed: true });
      alert("Job confirmed as completed. Payment will be processed.");
      navigate("/dashboard");
    } catch (error) {
      console.error("Error confirming job:", error.message);
    }
  };

  return (
    <div>
      <h2>Confirm Job Completion</h2>
      <p>Are you sure your job has been completed? Confirming will process your payment.</p>
      <button onClick={handleConfirm}>Confirm Completion</button>
    </div>
  );
};

export default ConfirmJobCompletion;
